<template>
  <div class="option" v-if="!iframe" :style="{ color, fontSize }">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'TextBox',
  props: {
    text: String,
    color: String,
    fontSize: String
  },
  data() {
    return {
      iframe: false
    }
  },
  methods: {
    
  },
  computed: {
   
  },
  mounted() {
    if(window.location !== window.parent.location) {
      this.iframe = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  @media (max-width: 700px) {
    display: none;
  }
}
</style>